import script from "./_ticket-family-slider-dots.vue?vue&type=script&setup=true&lang=ts"
export * from "./_ticket-family-slider-dots.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__